import styled from "@emotion/styled/macro";

type BoxProps = {
  display?: React.CSSProperties["display"];
  flexDirection?: React.CSSProperties["flexDirection"];
  marginTop?: string;
  marginLeft?: string;
  marginRight?: string;
  marginBottom?: string;
  margin?: string;
  justifyContent?: React.CSSProperties["justifyContent"];
  alignItems?: React.CSSProperties["alignItems"];
  gap?: React.CSSProperties["gap"];
  padding?: string;
  paddingTop?: string;
  paddingLeft?: string;
  paddingRight?: string;
  paddingBottom?: string;
  overflow?: React.CSSProperties["overflow"];
  flex?: React.CSSProperties["flex"];
};

const Box = styled.div<BoxProps>`
  display: ${({ display }) => display};
  flex-direction: ${({ flexDirection }) => flexDirection};
  margin: ${({ margin }) => margin};
  margin-top: ${({ marginTop }) => marginTop};
  margin-left: ${({ marginLeft }) => marginLeft};
  margin-right: ${({ marginRight }) => marginRight};
  margin-bottom: ${({ marginBottom }) => marginBottom};
  align-items: ${({ alignItems }) => alignItems};
  padding: ${({ padding }) => padding};
  padding-top: ${({ paddingTop }) => paddingTop};
  padding-left: ${({ paddingLeft }) => paddingLeft};
  padding-right: ${({ paddingRight }) => paddingRight};
  padding-bottom: ${({ paddingBottom }) => paddingBottom};
  justify-content: ${({ justifyContent }) => justifyContent};
  gap: ${({ gap }) => gap};
  overflow: ${({ overflow }) => overflow};
  flex: ${({ flex }) => flex};
`;

export type { BoxProps };
export { Box };
